<section class="c-cover c-cover--basic t-flag-grupo-c3" id="inicio">

  <div class="c-cover__image">
    <!-- <red-marathon-logo class="logo"></red-marathon-logo> -->
    <div class="c-cover__image">
      <img class="c-cover__image-logo"
           src="assets/images/logos/red1000.svg"
           alt="redação nota 1000">
    </div>
  </div>

  <h1 class="c-cover__main-title omega">
    Prezada escola parceira
  </h1>

  <div class="c-cover__content">

    <p class="u-margin-bottom">
      Atualizamos o sistema da plataforma para avaliações no modelo Enem.
      As mudanças aplicadas foram pensadas com o intuito de otimizar o 
      trabalho de correção e de prover uma devolutiva mais precisa e clara para os alunos. 
      Para isso, foram criados novos bandeiramentos para Língua Portuguesa, de modo a especificar melhor os problemas que podem aparecer no texto. 
      Como exemplo, o bandeiramento “Vírgula”, que antes abarcava diversos sinais de pontuação, foi fragmentado em bandeirinhas mais específicas,
      como “Ponto final”, “Travessão” e outros sinais de pontuação. O mesmo ocorre para sinais gráficos de acentuação, como o acento agudo ou circunflexo,
      que agora possuem bandeiramentos específicos. Não somente Língua Portuguesa (Competência 1), mas também Defesa/Coerência (Competência 3) também recebeu novos bandeiramentos. 
      Se antes possuíamos uma bandeirinha que abarcava as diversas possibilidades de falhas na argumentação (Falta de informatividade), hoje possuímos bandeiramentos mais específicos a respeito desses problemas,
      como “Informação sem função argumentativa”, “Falha no projeto textual” e “Distanciamento da temática”.
      Por fim, outra grande mudança na grade avaliativa do Enem é a implementação de bandeirinhas para identificar os elementos da proposta de intervenção, 
      que tem como objetivo esclarecer ao estudante quais os elementos estão dispostos na proposta e, portanto, quais faltam. 

      Tais modificações visam a aprimorar a devolutiva ao estudante e promover uma correção mais instrutiva.
    </p>

    <h3 class="c-cover__list-title">
      Competência 1
    </h3>
    <p>
      Foram adicionadas mais opções de bandeirinhas relativas à avaliação de Língua Portuguesa com o objetivo de indicar com maior clareza o que deve ser ajustado no texto, 
      fazendo com que o feedback ao aluno seja mais claro e, com isso, ele possa aprimorar o seu processo de produção textual.
    </p>
 
    <div class="c-new-grid-announcement__card--group u-margin-bottom">
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--danger"> 
        <p class="c-new-grid-announcement__card-text">Vírgula</p>
        <p class="c-new-grid-announcement__card-text">Ponto final</p>
        <p class="c-new-grid-announcement__card-text">Travessão</p>
        <p class="c-new-grid-announcement__card-text">Pontuação (Outros)</p>
        <p class="c-new-grid-announcement__card-text">Ortografia</p>
        <p class="c-new-grid-announcement__card-text">Hífen</p>
        <p class="c-new-grid-announcement__card-text">Letra maiúscula/minúscula</p>
        <p class="c-new-grid-announcement__card-text">Acento agudo</p>
      </div>
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--danger"> 
        <p class="c-new-grid-announcement__card-text">Sinal de nasalização</p>
        <p class="c-new-grid-announcement__card-text">Acento circunflexo</p>
        <p class="c-new-grid-announcement__card-text">Crase</p>
        <p class="c-new-grid-announcement__card-text">Vocabulário</p>
        <p class="c-new-grid-announcement__card-text">Ilegível</p>
        <p class="c-new-grid-announcement__card-text">Concordância</p>
        <p class="c-new-grid-announcement__card-text">Regência</p>
        <p class="c-new-grid-announcement__card-text">Colocação Pronominal</p>
        <p class="c-new-grid-announcement__card-text">Paralelismo sintático  </p>
      </div>
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--danger"> 
        <p class="c-new-grid-announcement__card-text">Ausência</p>
        <p class="c-new-grid-announcement__card-text">Excesso</p>
        <p class="c-new-grid-announcement__card-text">Justaposição</p>
        <p class="c-new-grid-announcement__card-text">Truncamento</p>
        <p class="c-new-grid-announcement__card-text">Oralidade</p>
        <p class="c-new-grid-announcement__card-text">Parágrafo frasal</p>
        <p class="c-new-grid-announcement__card-text">Sintaxe simples</p>
        <p class="c-new-grid-announcement__card-text">Período bem formulado  </p>
      </div>
    </div>

    <h3 class="c-cover__list-title">
      Competência 2
    </h3>
    <p>
      A Competência que avalia gênero e tema também possui bandeirinhas novas. Agora é possível apontar que o repertório é limitado aos textos da coletânea, 
      característica que limita a nota da C2 a 120 pontos, e indicar falha na interlocução (por exemplo, nos casos em que há uso da primeira pessoa do singular ou de expressões como “você”). 
    </p>

    <div class="c-new-grid-announcement__card--group u-margin-bottom">
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--warn"> 
        <p class="c-new-grid-announcement__card-text">Gênero inadequado</p>
        <p class="c-new-grid-announcement__card-text">Falta parte do gênero</p>
        <p class="c-new-grid-announcement__card-text">Cópia</p>
        <p class="c-new-grid-announcement__card-text">Falha na interlocução</p>
        <p class="c-new-grid-announcement__card-text">Rep. Não legitimado</p>
      </div>
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--warn"> 
        <p class="c-new-grid-announcement__card-text">Rep.Fora do Tema</p>
        <p class="c-new-grid-announcement__card-text">Rep.Limitado a Coletânea</p>
        <p class="c-new-grid-announcement__card-text">Repertório Pertinente !</p>
        <p class="c-new-grid-announcement__card-text">Repertório Produtivo !</p>
      </div>
   
    </div>

    <h3 class="c-cover__list-title">
      Competência 3
    </h3>
    <p>
      Criamos novas bandeirinhas para situações mais específicas, como desenvolvimento limitado das ideias, 
      falha na continuidade do projeto de texto ou trechos em que a redação se afasta completamente do tema proposto. 
    </p>

    <div class="c-new-grid-announcement__card--group u-margin-bottom">
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--customPurple"> 
        <p class="c-new-grid-announcement__card-text">Trecho confuso</p>
        <p class="c-new-grid-announcement__card-text">Trecho desconectado</p>
        <p class="c-new-grid-announcement__card-text">Trecho Contraditório</p>
        <p class="c-new-grid-announcement__card-text">Trecho circular</p>
        <p class="c-new-grid-announcement__card-text">Falha no projeto textual</p>
        <p class="c-new-grid-announcement__card-text">Informação sem função argumentativa</p>
      </div>
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--customPurple"> 
        <p class="c-new-grid-announcement__card-text">Distanciamento da proposta temática</p>
        <p class="c-new-grid-announcement__card-text">Relação entre as ideias</p>
        <p class="c-new-grid-announcement__card-text">Desenvolver mais</p>
        <p class="c-new-grid-announcement__card-text">Argum.Bem Colocado !</p>
        <p class="c-new-grid-announcement__card-text">Boa artic.de ideias !</p>
        <p class="c-new-grid-announcement__card-text">Boa retomada !</p>
        
      </div>
   
    </div>
    
    <h3 class="c-cover__list-title">
      Competência 4
    </h3>
    <p>
      As bandeirinhas foram reformuladas, sendo divididas por ocorrências de inadequação ou ausência de conectivos e/ou operadores 
      argumentativos inter e intraparágrafo (entre ou dentro dos parágrafos).
    </p>

    
    <div class="c-new-grid-announcement__card--group u-margin-bottom">
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--info"> 
        <p class="c-new-grid-announcement__card-text">Falha coesiva entre períodos</p>
        <p class="c-new-grid-announcement__card-text">Falha coesiva entre os parágrafos</p>
        <p class="c-new-grid-announcement__card-text">Repetição de palavras</p>
      </div>
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--info"> 
        <p class="c-new-grid-announcement__card-text">Boa conex. Paragrafos !</p>
        <p class="c-new-grid-announcement__card-text">Boa coord. entre frases !</p>
        <p class="c-new-grid-announcement__card-text">Boa progressão textual !</p>
      </div>
    </div>

    <h3 class="c-cover__list-title">
      Competência 5
    </h3>
    <p>
      Com a intenção de facilitar uma correção mais instrutiva aos alunos, adicionamos bandeirinhas personalizadas para a avaliação das propostas de intervenção. 
    </p>
    <div class="c-new-grid-announcement__card--group u-margin-bottom">
      <div class="c-new-grid-announcement__card c-new-grid-announcement__card--success"> 
        <p class="c-new-grid-announcement__card-text">Agente</p>
        <p class="c-new-grid-announcement__card-text">Ação</p>
        <p class="c-new-grid-announcement__card-text">Modo</p>
        <p class="c-new-grid-announcement__card-text">Efeito</p>
        <p class="c-new-grid-announcement__card-text">Detalhamento</p>
        <p class="c-new-grid-announcement__card-text">Elemento Nulo</p>
        <p class="c-new-grid-announcement__card-text">Proposta completa</p>
      </div>
    </div>
 
  </div>

</section>
